import { EventSelectorBar } from "../components/organisms/EventSelectorBar.jsx";
import { HomeMenu } from "../components/organisms/HomeMenu.jsx";

export const Home = () => {
  return (
    <>
      <EventSelectorBar />
      <HomeMenu />
    </>
  );
}